import produce from 'immer-legacy';

import { LOGOUT, SESSION_TIMEOUT } from 'data_system/token_auth/actionTypes';
import {
  FETCH_EXPERIENCES_REQUEST,
  FETCH_EXPERIENCES_SUCCESS,
  FETCH_EXPERIENCES_ERROR,
  FETCH_EXPERIENCE_REQUEST,
  FETCH_EXPERIENCE_SUCCESS,
  CLEAR_SEARCH,
} from '../actions/experienceActionTypes';

// Initial state to initialize reducer
const initialState = {
  experiences: [],
  experience: {},
  search: '',
  firstLoad: true,
  fetching: false,
  error: null,
};

export const experiencesReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case SESSION_TIMEOUT:
    case LOGOUT:
      return initialState;

    case FETCH_EXPERIENCES_REQUEST:
      state.search = action.search || '';
      state.firstLoad = false;
      state.fetching = true;
      break;

    case FETCH_EXPERIENCES_SUCCESS: {
      state.experiences = action.experiences;
      state.fetching = false;
      state.error = null;
      break;
    }

    case FETCH_EXPERIENCES_ERROR: {
      state.fetching = false;
      state.error = action.error;
      break;
    }

    case FETCH_EXPERIENCE_REQUEST:
      state.fetching = true;
      break;

    case FETCH_EXPERIENCE_SUCCESS: {
      state.experience = action.experience;
      state.fetching = false;
      state.error = null;
      break;
    }

    case CLEAR_SEARCH:
      state.search = '';
      state.fetching = true;
      break;

    default:
      break;
  }
  return state;
});
